import type { ComponentPropsWithoutRef, ElementType, ReactNode } from 'react'

type AsProp<T extends ElementType> = {
  as?: T
}

type PolymorphicProps<T extends ElementType> = AsProp<T> &
  Omit<ComponentPropsWithoutRef<T>, keyof AsProp<T>> & {
    children: ReactNode
    className?: string
  }

const mergeClassName = (baseClassName: string, className?: string): string =>
  className ? `${baseClassName} ${className}` : baseClassName

export const StorefrontProductTopGrid = ({
  className,
  children,
}: {
  className?: string
  children: ReactNode
}) => (
  <section
    className={mergeClassName(
      'grid min-w-0 items-start gap-6 xl:grid-cols-[minmax(0,1.06fr)_minmax(360px,0.94fr)]',
      className,
    )}
  >
    {children}
  </section>
)

export const StorefrontProductSurfaceCard = <T extends ElementType = 'section'>({
  as,
  className,
  children,
  ...props
}: PolymorphicProps<T>) => {
  const Component = as ?? 'section'

  return (
    <Component className={mergeClassName('shop-surface rounded-3xl p-5 sm:p-6', className)} {...props}>
      {children}
    </Component>
  )
}

export const StorefrontProductInnerCard = <T extends ElementType = 'div'>({
  as,
  className,
  children,
  ...props
}: PolymorphicProps<T>) => {
  const Component = as ?? 'div'

  return (
    <Component className={mergeClassName('rounded-2xl border border-slate-200/90 bg-white/90 p-3.5', className)} {...props}>
      {children}
    </Component>
  )
}
